module.exports = __webpack_public_path__ + "img/collapse_icon_left.d42d3089.svg";